export const SettlementFragmentOverview = gql`
  fragment SettlementFragmentOverview on Settlement {
    id
    uuid
    finixSettlementId
    estimatedBankDepositDate
    netAmountCents
    status
  }
`

export const SettlementFragment = gql`
  fragment SettlementFragment on Settlement {
    id
    uuid
    finixSettlementId
    status
    netAmountCents
    totalAmountCents
    totalFeeCents
    accrualWindowDisplay
    accrualStartAt
    accrualEndAt
    estimatedBankDepositDate
    finixSettlementApprovedAt
    revenueAllocationByGeneralLedgerNumber {
      glNumber
      revenueCents
      percentage
    }
    generalLedgerNumbers {
      ...GeneralLedgerNumberFragment
    }
    organization {
      id
      paymentProviderFormatted
      timeZone
    }
    paymentTransfers {
      ...SettlementPaymentTransferFragment
    }
  }
`

export const SettlementPaymentTransferFragment = gql`
  fragment SettlementPaymentTransferFragment on PaymentTransfer {
    id
    finixId
    createdAt
    paymentMethod
    revenueCents
    totalAmountCents
    serviceFeeCents
    isRefund
    generalLedgerNumbers {
      id
      glNumber
    }
    records {
      id
      uuid
      isTest
      isDraft
      currentUserHasAccess
      displayIdentifier
      organization {
        id
        slug
      }
    }
    recordTaskPayments {
      id
      recordTaskFees {
        ...SettlementPaymentTransferRecordTaskFeeFragment
      }
    }
  }
`

export const SettlementPaymentTransferRecordTaskFeeFragment = gql`
  fragment SettlementPaymentTransferRecordTaskFeeFragment on RecordTaskFee {
    id
    totalWhenInvoiceRequestedCents
    description
    feeVersion {
      id
      fee {
        id
        name
      }
      generalLedgerNumber {
        id
        glNumber
      }
    }
  }
`
